// extracted by mini-css-extract-plugin
export default {"container":"Switch_container__dWqjp","vertical":"Switch_vertical__YyZqw"};